"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _Item = _interopRequireDefault(require("./Item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useStyles = (0, _styles.makeStyles)({
  paper: {
    backgroundColor: 'transparent'
  }
});
var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var onClick = function onClick(e) {
    setAnchorEl(e.currentTarget);
  };
  var open = Boolean(anchorEl);
  var closeMenu = function closeMenu() {
    return setAnchorEl(null);
  };
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    className: (0, _classnames["default"])({
      'opacity-75': open
    }),
    onClick: onClick,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    classes: classes,
    anchorEl: anchorEl,
    onClose: closeMenu,
    open: open,
    elevation: 4,
    anchorPosition: {
      top: 100
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-56 bg-card"
  }, children({
    closeMenu: closeMenu
  }))));
});
var _default = exports["default"] = Menu;
//# sourceMappingURL=Menu.js.map